import type { DaySummary } from "./api";

export function fillMissingDays(days: DaySummary[], count: number, tz: string): DaySummary[] {
  const out: DaySummary[] = [];
  const fmt = new Intl.DateTimeFormat("en-CA", { timeZone: tz });
  const today = new Date();
  const map = new Map(days.map((d) => [d.day, d]));
  for (let i = count - 1; i >= 0; i--) {
    const d = new Date(today);
    d.setUTCDate(d.getUTCDate() - i);
    const key = fmt.format(d);
    out.push(map.get(key) ?? { day: key, calories: 0, protein_g: 0, meals: 0 });
  }
  return out;
}
